// extracted by mini-css-extract-plugin
export var getting_started_button = "GetStartedButton-module--getting_started_button--1Kk0H";
export var pressed = "GetStartedButton-module--pressed--xcWI9";